export default __webpack_public_path__ + "static/media/BOD Regular Meeting 10 November 2021.6c7b0713.pdf";